import React, { FC } from "react";
import type { UniversalPaymentAccountUPAProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const UniversalPaymentAccountUPA: FC<
  UniversalPaymentAccountUPAProps
> = ({ content, cover }) => {
  return (
    <section className="universalPaymentAccountUPA">
      <div className="wrapper">
        <TextCols content={content} size="md" maxTitleWidth={740} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="universalPaymentAccountUPA--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
